import React, { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Input } from 'reactstrap'

import { customToast, ROUTES } from '@common'
import { Loader } from '@components'
import { useOrderRedux } from '@hooks'

export default function OrderStatusPage() {
    const navigate = useNavigate()
    const { isLoading, fetchOrderByNumber } = useOrderRedux()
    const orderNumberRef = useRef(null)
    const [orderNumber, setOrderNumber] = useState('')

    const handleInputChange = e => {
        const value = e.target.value
        if (/^\d*$/.test(value)) {
            setOrderNumber(value)
        } else {
            customToast.error('Please enter the number')
        }
    }

    const handleKeyDown = e => {
        if (e.key === 'Enter') {
            e.preventDefault()
            onSearch()
        }
    }

    const onSearch = async () => {
        const res = await fetchOrderByNumber({ orderNumber, isForStatusPage: true })
        if (res.meta.requestStatus === 'fulfilled') {
            navigate(ROUTES.Order.number.replace(':orderNumber', orderNumber))
        } else {
            customToast.error('Search Order Failure')
            customToast.error(res.payload)
        }
    }

    return (
        <div style={{ textAlign: 'center', height: '80vh' }}>
            {isLoading && <Loader />}
            <h1>Check Order Status</h1>
            <p>Enter your order ID to check if your food is ready for collection at the respective stall counter.</p>
            <div className="d-flex justify-content-center">
                <Input
                    ref={orderNumberRef}
                    className="w-50"
                    type="number"
                    placeholder="Order ID"
                    value={orderNumber}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                />
                <button className="btn btn-primary" onClick={onSearch} disabled={!orderNumber}>
                    <i className="bx bx-search"></i>
                </button>
            </div>
        </div>
    )
}
